// extracted by mini-css-extract-plugin
module.exports = {"filters":"filters--2qPIk","tiles-container":"tiles-container--2qPIk","banners":"banners--2qPIk"};